
export class HotelPageConfiguration {
    ID: number;
    Guid: string;
    CountryID: number;
    Name: string;
    Alias: string;
    CorporationLogo: string;
    CorporationLogoText: string;
    Logo: string;
    LogoText: string;
    PromotionOfferDetails: string;
    AdditionalFieldsFormID: number;
    Format: string;
    RegistrationInfo: string;
    TermsText: string;
    TermsUrl: string;
    PromotionHidePrefContact: boolean;
    PinRegistrationFooterText: string;
    PartnerCodeSelectText: string;
    PartnerCodeSelectValidationText: string;
    PageTitle: string;
    // PageDescription: string;
    // PageMetaImg: string = "https://aplanbyvolvo.azureedge.net/media/av/media/aplan/social/2021-volvo-meta-image.jpg";
}
